<template>
  <a-tooltip
    v-if="content"
    class="ml-2"
  >
    <template slot="title">
      {{ content }}
    </template>
    <a-icon
      type="question-circle"
      theme="filled"
      class="text-gray-500"
      :style="{ fontSize: '12px'}"
    />
  </a-tooltip>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Hint',

  props: {
    content: {
      type: String,
      default: ''
    }
  }
})
</script>
